import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const DocumentationTranslationKeys = {
  createDirectory: translationKey('create_directory'),
  createDocumentation: translationKey('create_documentation'),
  directoryNameFieldLabel: translationKey('directory_name_field_label'),
  documentLinkExpiredInfo: translationKey('document_link_expired_info'),
  addVersionFileHint: translationKey('documentation_add_version_file_hint'),
  addVersionMapPdfInfo: translationKey('documentation_add_version_map_pdf_info'),
  addVersionMapWarning: translationKey('documentation_add_version_map_warning'),
  addVersionMarkCurrent: translationKey('documentation_add_version_mark_current'),
  addVersionNameLabel: translationKey('documentation_add_version_name_label'),
  addVersionNumberLabel: translationKey('documentation_add_version_number_label'),
  addVersionTitle: translationKey('documentation_add_version_title'),
  author: translationKey('documentation_author'),
  breadcrumbExpandHint: translationKey('documentation_breadcrumb_expand_hint'),
  browserCurrentVersion: translationKey('documentation_browser_current_version'),
  browserNoCurrentVersion: translationKey('documentation_browser_no_current_version'),
  browserNoVersions: translationKey('documentation_browser_no_versions'),
  changedMeanwhile: translationKey('documentation_changed_meanwhile'),
  columnLabelCountRelatedIssues: translationKey('documentation_column_label_count_related_issues'),
  columnLabelCreatedAt: translationKey('documentation_column_label_created_at'),
  columnLabelCreatedBy: translationKey('documentation_column_label_created_by'),
  columnLabelCurrentVersionNumber: translationKey('documentation_column_label_current_version_number'),
  columnLabelDirectory: translationKey('documentation_column_label_directory'),
  columnLabelExportedFromIssue: translationKey('documentation_column_label_exported_from_issue'),
  columnLabelLevel: translationKey('documentation_column_label_level'),
  columnLabelModifiedAt: translationKey('documentation_column_label_modified_at'),
  columnLabelModifiedBy: translationKey('documentation_column_label_modified_by'),
  columnLabelName: translationKey('documentation_column_label_name'),
  columnLabelNumber: translationKey('documentation_column_label_number'),
  columnLabelSite: translationKey('documentation_column_label_site'),
  columnLabelState: translationKey('documentation_column_label_state'),
  creationDate: translationKey('documentation_creation_date'),
  currentVersionNumberLabel: translationKey('documentation_current_version_number_label'),
  directoryContainsMatchingFiles: translationKey('documentation_directory_contains_matching_files'),
  dropFilesToDirectory: translationKey('documentation_drop_files_to_directory'),
  dropFilesToMoveToDirectory: translationKey('documentation_drop_files_to_move_to_directory'),
  emptyInfo: translationKey('documentation_empty_info'),
  exportHintAsNew: translationKey('documentation_export_hint_as_new'),
  exportHintAsVersion: translationKey('documentation_export_hint_as_version'),
  exportVersionCurrentNotSaved: translationKey('documentation_export_version_current_not_saved'),
  exportVersionNameNotSaved: translationKey('documentation_export_version_name_not_saved'),
  exportedAsNewToast: translationKey('documentation_exported_as_new_toast'),
  fileNotSupportedAsMap: translationKey('documentation_file_not_supported_as_map'),
  fileNotUsedAsMap: translationKey('documentation_file_not_used_as_map'),
  filterAction: translationKey('documentation_filter_action'),
  filteringUnavailable: translationKey('documentation_filtering_unavailable'),
  goToSourceIssueAction: translationKey('documentation_go_to_source_issue_action'),
  hideIssuesAction: translationKey('documentation_hide_issues_action'),
  itemFolderCountSuffix: translationKey('documentation_item_folder_count_suffix'),
  itemFolderWithCount: translationKey('documentation_item_folder_with_count'),
  linkedToDocumentationToast: translationKey('documentation_linked_to_documentation_toast'),
  linkedToVersionToast: translationKey('documentation_linked_to_version_toast'),
  mapCurrentVersionNotSuitable: translationKey('documentation_map_current_version_not_suitable'),
  mapDocumentationWithdrawn: translationKey('documentation_map_documentation_withdrawn'),
  mapInvalidFile: translationKey('documentation_map_invalid_file'),
  mapNoCurrentVersion: translationKey('documentation_map_no_current_version'),
  mapReasonMultiPagePdf: translationKey('documentation_map_reason_multi_page_pdf'),
  mapReasonUnsupportedFormat: translationKey('documentation_map_reason_unsupported_format'),
  mapVersionWithdrawn: translationKey('documentation_map_version_withdrawn'),
  nameFieldLabel: translationKey('documentation_name_field_label'),
  noCurrentVersion: translationKey('documentation_no_current_version'),
  numberFieldLabel: translationKey('documentation_number_field_label'),
  progressPanelPin: translationKey('documentation_progress_panel_pin'),
  progressPanelUnpin: translationKey('documentation_progress_panel_unpin'),
  returnToSearch: translationKey('documentation_return_to_search'),
  returnToSearchTooltip: translationKey('documentation_return_to_search_tooltip'),
  searchNavigatedAway: translationKey('documentation_search_navigated_away'),
  showIssuesAction: translationKey('documentation_show_issues_action'),
  sourceIssueMissingTooltip: translationKey('documentation_source_issue_missing_tooltip'),
  statePublished: translationKey('documentation_state_published'),
  stateWithdrawn: translationKey('documentation_state_withdrawn'),
  useAsMap: translationKey('documentation_use_as_map'),
  versionAddedAsCurrentToast: translationKey('documentation_version_added_as_current_toast'),
  versionAddedToast: translationKey('documentation_version_added_toast'),
  versionStateCurrent: translationKey('documentation_version_state_current'),
  versionStateOutdated: translationKey('documentation_version_state_outdated'),
  versionStateWithdrawn: translationKey('documentation_version_state_withdrawn'),
  versionWithdrawnNotice: translationKey('documentation_version_withdrawn_notice'),
  documentsAddMediaButtonSubtitle: translationKey('documents_add_media_button_subtitle'),
  editDirectory: translationKey('edit_directory'),
  folderUploadCreatingFolders: translationKey('folder_upload_creating_folders'),
  newDirectory: translationKey('new_directory'),
  uploadDirectory: translationKey('upload_directory'),
  uploadFiles: translationKey('upload_files'),
} as const satisfies Record<string, TranslationKey>;
